import styled from 'styled-components';
import CustomBlockButton from "../../../../../../../../../components/button/CustomBlockButton";

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const StyledItem = styled.div`
    padding: 10px;
    border: 1px solid #333;
    border-radius: 5px;

    .address {
        font-weight: bold;
    }

    .type{
        font-size: 12px;
    }
`;

export function WegetAddressList({
    filteredRackLocations,
    onSelect
}) {
    return (
        <>
            <StyledContainer>
                {/* <CustomBlockButton
                    type='button'
                    onClick={() => onSelect('')}
                >
                    지정안함
                </CustomBlockButton> */}
                {filteredRackLocations?.map(rackLocation => {
                    return (
                        <StyledItem
                            key={rackLocation?.address}
                            onClick={() => onSelect(rackLocation)}
                        >
                            <div className='address'>
                                {rackLocation?.address}
                            </div>
                            <div className='type'>
                                {rackLocation?.type} ({rackLocation?.items?.length}항목)
                            </div>
                        </StyledItem>
                        // <CustomBlockButton
                        //     type='button'
                        //     key={enabledLocationAddress}
                        //     onClick={() => handleSelect(enabledLocationAddress)}
                        // >
                        //     {enabledLocationAddress}
                        // </CustomBlockButton>
                    );
                })}
            </StyledContainer>
        </>
    );
}